import React from 'react';

const Projects: React.FC = () => {
  return (
    <div style={{padding: '24px'}}>
      <h1>Projects</h1>
      <img src="/images/projects.svg" alt="Projects" style={{maxWidth: '100%', height: 'auto'}} />
      {/* <ul style={{maxWidth: 800}}>
        <li><strong>Project A</strong>: A responsive marketing site built with React.</li>
        <li><strong>Project B</strong>: An internal dashboard with real-time data visualizations.</li>
        <li><strong>Project C</strong>: E-commerce prototype with performance optimizations.</li>
      </ul> */}
    </div>
  );
};

export default Projects;
